import Vue from 'vue';
import { apiData } from '../../common/dataService';
import { getItem, setItem } from '../../common/utils';
import store from '../index';
import installPermission from '../../common/installPermission';
import { scopeMap } from '../../common/optionMap';
const initialInfo = getItem('local', 'twe_userInfo');
// initial state
const state = {
  baseInfo: initialInfo ? JSON.parse(initialInfo) : {},
  showLeftMenu: false,
  accessibleMenu: {},
  isCluePoolName: '',
  showTopMenu: null
};

// getters
const getters = {};

//actions
const actions = {
  async fetchAccount({ commit, dispatch }, data) {
    let res = await apiData('get', 'user/getUserInfo', data);

    let { searchDimension } = res.funcPermissions;
    searchDimension = searchDimension.map(item => {
      if (item.key === 'all' || item.key === '0') {
        return {
          ...item,
          key: '0',
          label: '全部'
        };
      }
      return {
        ...item,
        label: scopeMap[item.key]
      };
    });
    res.funcPermissions.searchDimension = searchDimension;
    console.log(searchDimension);
    commit('setAccount', res);
    store._actions.getClickNum[0]({
      clickcontact_volume: res.clickcontact_volume,
      clickedContacts: res.clickedContacts,
      taskQuota: res.taskQuota,
      usedTaskQuota: res.usedTaskQuota,
      refresh: 1
    });
    return res;
  }
};

// mutations
const mutations = {
  setAccount(state, data) {
    state.baseInfo = data;
    if (
      data &&
      'needLeftMenu' in data &&
      typeof data.needLeftMenu === 'boolean'
    ) {
      state.showLeftMenu = data.needLeftMenu;
    } else {
      state.showLeftMenu = true;
    }

    //用户root 与分销不返回配置字段
    if (data.role === 'root' || data.role === 'agent') {
      state.isCluePoolName = '我的线索';
    } else {
      if (data && 'accessibleMenu' in data) {
        state.accessibleMenu = data.accessibleMenu;
        if (
          state.accessibleMenu &&
          state.accessibleMenu.cluePool &&
          state.accessibleMenu.cluePool.alias
        ) {
          state.isCluePoolName = state.accessibleMenu.cluePool.alias;
          window.localStorage.setItem(
            'isCluePoolName',
            state.accessibleMenu.cluePool.alias
          );
        } else {
          if (window.localStorage.getItem('isCluePoolName')) {
            window.localStorage.removeItem('isCluePoolName');
          }
          state.isCluePoolName = '我的线索';
        }
      }
    }

    if (
      data &&
      data.hasOwnProperty('customFeatures') &&
      data.customFeatures.hasOwnProperty('sea')
    ) {
      window.localStorage.setItem(
        'publicSeaName',
        data.customFeatures.sea.alias
      );
    } else {
      window.localStorage.setItem('publicSeaName', '');
    }
    // 公海名称配置化

    if (data.role === 'root' || data.role === 'agent') {
      state.showTopMenu = true;
    } else {
      if (
        data &&
        'needTopMenu' in data &&
        typeof data.needTopMenu === 'boolean'
      ) {
        state.showTopMenu = data.needTopMenu;
      }
    }

    setItem('local', 'twe_userInfo', JSON.stringify(data));
    installPermission(Vue, data);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/account.js